function writeLog(message, level) {
  if (process.env.NODE_ENV === 'development') {
    const date = new Date();
    const formattedMessage = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} ${message}`;

    if (level === 'warning') {
      console.warn(formattedMessage);
    } else if (level === 'info') {
      console.info(formattedMessage);
    } else {
      console.log(formattedMessage);
    }
  }
}

export function logWarning(message) {
  return writeLog(message, 'warning');
}

export function log(message) {
  return writeLog(message, 'info');
}
